﻿import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { logger } from '@/utils/logger';

import App from './App.tsx';

import './index.css';

window.addEventListener('unhandledrejection', (event: PromiseRejectionEvent) => {
  event.preventDefault();
  logger.error('Unhandled Promise Rejection', {
    reason: event.reason?.message || String(event.reason),
    stack: event.reason?.stack,
  });
});

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Failed to find the root element');

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>
);
